import { Sparkles } from "lucide-react";

const MobileStickyCTA = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 border-t border-[#8E7CC3]/15 bg-white/90 p-3 backdrop-blur-md md:hidden" data-testid="mobile-sticky-cta">
    <a
      href="#quote"
      data-testid="mobile-sticky-quote-button"
      className="flex items-center justify-center gap-2 rounded-full bg-[#8E7CC3] px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-white shadow-[0_8px_30px_rgb(142,124,195,0.4)]"
    >
      <Sparkles className="h-4 w-4" aria-hidden="true" />
      Get a Free Quote
    </a>
  </div>
);

export default MobileStickyCTA;
